import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  user: {
    id: null,
    name: null,
    session_key: null,
    email: null,
    examCompleted: false,
    exam_attempts: null,
    completedSectionIds: [],
    admin_status: null,
    exam_status: null,
    exam_resume_id: null,
    ads_limit: 1,
    experience_set: null,
  },
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    storeUserDetails: (state, action) => {
      let update = {
        id: action.payload.id,
        name: action.payload.name,
        session_key: action.payload.session_key,
        email: action.payload.email,
        examCompleted: action.payload.hasDoneExam ?? false,
        exam_attempts: action.payload.exam_attempts ?? null,
        completedSectionIds: action.payload.completedSectionIds ?? [],
        admin_status: action.payload.admin_status ?? null,
        exam_status: action.payload.exam_status ?? null,
        exam_resume_id: action.payload.exam_resume_id ?? null,
        ads_limit: action.payload.ads_limit ?? 1,
        experience_set: action.payload.experience_set ?? null,
      };
      state.userData = update;
    },
    logoutUser: (state) => {
      state.userData = initialState.user;
    },
  },
});

export const { storeUserDetails, logoutUser } = userSlice.actions;

export default userSlice.reducer;
